"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
exports.isDevelop = process.env.NODE_ENV === 'development';
exports.toNum = (i) => {
    if (typeof i === 'number')
        return i;
    if (typeof i === 'string') {
        const id = parseFloat(i);
        if (Number.isNaN(id)) {
            throw new Error(`passed invalid ID ${i}`);
        }
        return id;
    }
    if (i === undefined || i === null) {
        throw new Error('cannot toNum of undefined or null');
    }
    return i.id;
};
function createAction(setRunning, setError, cb) {
    return mobx_1.flow(function* (...args) {
        setRunning(true);
        setError(undefined, args);
        try {
            const resolved = yield cb(...args);
            return resolved;
        }
        catch (err) {
            setError(err, args);
            throw err;
        }
        finally {
            setRunning(false);
        }
    });
}
exports.createAction = createAction;
/** Wrap your actions in this if you want two fetchMyThing(1) calls to share the same network request */
exports.shareConcurrentCalls = (fn) => {
    const cache = {};
    return async (...args) => {
        const serialized = JSON.stringify(args);
        if (cache[serialized])
            return cache[serialized];
        // we store the Promise in cache, until it's been resolved
        cache[serialized] = fn(...args);
        const resolved = await cache[serialized];
        delete cache[serialized];
        return resolved;
    };
};
const newIDStart = -1;
let newIDs = newIDStart;
exports.newID = () => (newIDs -= 1);
exports.isNewID = (i) => i <= newIDStart;
exports.stripNewID = (obj) => {
    if (exports.isNewID(obj.id)) {
        const { id: _ } = obj, out = __rest(obj, ["id"]);
        return out;
    }
    return obj;
};
//# sourceMappingURL=util.js.map